import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=4a6d2ef0&scoped=true"
import script from "./CampaignTable.vue?vue&type=script&lang=js"
export * from "./CampaignTable.vue?vue&type=script&lang=js"
import style0 from "./CampaignTable.vue?vue&type=style&index=0&id=4a6d2ef0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6d2ef0",
  null
  
)

export default component.exports